export default __webpack_public_path__ + "static/media/Splash_Mobile.55e7b6c8.gif";